/**
 * 仅解码本地 mslogin_token（不验签），用于补全 roles 等与缓存不一致的展示字段。
 */
export function parseMsloginTokenPayload(): Record<string, unknown> | null {
  try {
    const t = localStorage.getItem("mslogin_token");
    if (!t?.includes(".")) return null;
    const part = t.split(".")[1];
    if (!part) return null;
    const b64 = part.replace(/-/g, "+").replace(/_/g, "/");
    const pad =
      b64.length % 4 === 0 ? "" : "=".repeat(4 - (b64.length % 4));
    return JSON.parse(atob(b64 + pad)) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function getRolesFromMsloginToken(): string[] {
  const payload = parseMsloginTokenPayload();
  const r = payload?.roles;
  if (!Array.isArray(r)) return [];
  return r.filter((x): x is string => typeof x === "string" && !!x.trim());
}
